<template>
  <div class="attach-list">
    <div
      v-for="(attachment, index) in attachments"
      :key="index"
      class="attach-row"
    >
      <!-- Icono de tipo de archivo -->
      <v-icon size="15" color="#6B7280" class="attach-icon">
        {{ attachment.pathmedia ? 'mdi-image-outline' : 'mdi-file-outline' }}
      </v-icon>

      <!-- Nombre -->
      <span class="attach-name">{{ attachment.name }}</span>

      <!-- Acciones -->
      <div class="attach-actions">
        <AttachmentPreviewButton
          :attachment="previewAttachment(attachment)"
          :loading="loading"
          compact
          plain
          @preview="previewAttachmentForViewer"
        />

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
              class="attach-btn"
              :disabled="loading"
              v-bind="attrs"
              v-on="on"
              @click="viewAttachment(attachment)"
            >
              <v-icon size="13" color="#2D4B95">mdi-open-in-new</v-icon>
            </button>
          </template>
          <span>Visualizar en navegador</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
              class="attach-btn"
              :disabled="loading"
              v-bind="attrs"
              v-on="on"
              @click="downloadAttachment(attachment)"
            >
              <v-icon size="13" color="#2D4B95">mdi-cloud-download-outline</v-icon>
            </button>
          </template>
          <span>Descargar archivo</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import AttachmentPreviewButton from '@/components/Globals/Helpers/AttachmentPreviewButton'
  import { normalizeAttachmentForPreview } from '@/helpers/attachmentPreview'

  export default {
    name: 'AttachmentList',
    components: { AttachmentPreviewButton },
    
    props: {
      attachments: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    
    methods: {
      previewAttachment(attachment) {
        return normalizeAttachmentForPreview(attachment?.file || attachment)
      },

      previewAttachmentForViewer(attachment) {
        this.$emit('preview', attachment)
      },

      viewAttachment(attachment) {
        this.$emit('view', attachment, false);
      },
      
      downloadAttachment(attachment) {
        this.$emit('download', attachment);
      }
    }
  };
  </script>
  
  <style scoped>
.attach-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 200px;
  overflow-y: auto;
}

.attach-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #E5E8EF;
  background: #F8F9FC;
  transition: background 0.12s;
}

.attach-row:hover {
  background: #EEF2FF;
  border-color: #C7D2FE;
}

.attach-icon {
  flex-shrink: 0;
}

.attach-name {
  flex: 1;
  font-size: 12px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.attach-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.attach-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 5px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
}

.attach-btn:hover {
  background: #EEF2FF;
  border-color: #C7D2FE;
}

.attach-btn:disabled {
  opacity: 0.45;
  cursor: default;
}
</style>